import React, { useState } from 'react';
import './Header.css';

const Header = ({ scrollY, scrollToSection, handleLoginClick, isLoginPage = false, handleBackToHome }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavClick = (sectionId) => {
    if (isLoginPage) {
      // If on login page, navigate back to home first, then scroll to section
      handleBackToHome();
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      scrollToSection(sectionId);
    }
    setIsMenuOpen(false); // Close mobile menu after click
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
                      <div className="logo-section">
                        <button 
                          className="logo-button" 
                          onClick={() => handleNavClick('home')}
                          aria-label="Go to home"
                        >
                          <img src="/images/clulogo.png" alt="Carmel Lahaina Utility Services Logo" className="logo" />
                        </button>
                      </div>
          
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <ul className="nav-list">
              <li><button onClick={() => handleNavClick('home')}>HOME</button></li>
              <li><button onClick={() => handleNavClick('about')}>ABOUT</button></li>
              <li><button onClick={() => handleNavClick('team')}>TEAM</button></li>
              <li><button onClick={() => handleNavClick('account')}>MY ACCOUNT</button></li>
              <li><button onClick={() => handleNavClick('contact')}>CONTACT SALES</button></li>
            </ul>
          </nav>
          
          <div className="header-actions">
            <button 
              className="btn btn-primary"
              onClick={handleLoginClick}
            >
              Bill Pay
            </button>
            <button className="mobile-menu-toggle" onClick={toggleMenu}>
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
